import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router'
import { Layout } from 'antd';
import { DetailForm, AuthButton, AuthButtonAuthorities } from '../../core/CoreForm';
import { Header, ContentEx as Content, FooterButtonArea, Footer, FunctionTitle, CommonMessage } from '../../core/CorePageContents';
import styles from './QualificationDetail.module.css';
import * as Module from '../../../modules/prime/qualification/qualificationModule';
import * as Model from '../../../modules/prime/qualification/qualificationModel';
import * as CONSTANTS from '../../../constants/constants';
import * as constantsUtils from '../../../utils/constantsUtils';
import * as messagesUtils from '../../../utils/messagesUtils';
import * as formatUtils from '../../../utils/formatUtils';
import { storedApiResult, initApiResult } from '../../../modules/core/bffApiModule';
import { initMessages, message } from '../../../modules/core/commonMessageModule';
import { setMessages } from '../../../modules/core/commonMessageModule';
import AuthButtonStyles from "../../core/css/AuthButton.module.css";

interface titleInterface {
  title: string;
}

export const QualificationDetail = (props: titleInterface) => {

  const dispatch = useDispatch();
  const dataRow = useSelector(Module.storedDataRow);
  const apiResult = useSelector(storedApiResult);
  let history = useHistory();
  let loadingFlg = useSelector(Module.storedLoadingFlg);

  useEffect(() => {
    dispatch(Module.setLoadingFlg(false));
    },[]
  );

  useEffect(() => {
    // APIステータスが初期値の場合、詳細情報取得APIを実行します。
    if (CONSTANTS.API_STATUS_INITIAL === apiResult.status && "" === apiResult.requestMethod && !loadingFlg) {
      let initParam: Model.Criteria = {
        originalQualificationNo: "",
        originalQualificationName: "",
        originalQualificationId: dataRow.originalQualificationId,
        sortItem: "",
        sortOrder: "",
        offset: 0,
        limit: 10,
      }
      dispatch(Module.getDataDetailAsync(initParam));
    }

    // 詳細情報取得API実行後、APIエラーメッセージが設定されていたら一覧画面へ遷移します。
    if (dataRow.key === "" && CONSTANTS.API_STATUS_INITIAL !== apiResult.status && "" !== apiResult.errorCode && CONSTANTS.REQUEST_METHOD_GET === apiResult.requestMethod) {
      // 資格情報が存在しない（資格が削除済み）場合のメッセージを設定
      const setMessage: message = {
        message: messagesUtils.getMessage("ERROR_SELECT_DELETED_QUALIFICATION")
        , messageType: CONSTANTS.MESSAGE_TYPE_ERROR
      }
      dispatch(setMessages([setMessage]));
      history.push(CONSTANTS.PATH_PRIME_QUALIFICATIONS_LIST);
    }

    // 詳細情報取得API実行後、dataRow設定されていない場合一覧画面へ遷移します。
    if (dataRow.key === "" && CONSTANTS.API_STATUS_INITIAL !== apiResult.status && "" === apiResult.errorCode && CONSTANTS.REQUEST_METHOD_GET === apiResult.requestMethod) {
      history.push(CONSTANTS.PATH_PRIME_QUALIFICATIONS_LIST);
    }

   // 独自資格削除API実行後、APIエラーメッセージが設定されていない場合、一覧画面に遷移して削除成功メッセージを表示します。
    if (CONSTANTS.API_STATUS_INITIAL !== apiResult.status && "" === apiResult.errorCode && CONSTANTS.REQUEST_METHOD_DELETE === apiResult.requestMethod) {
      // 削除処理が実行されているので、loadingFlgをfalseに戻す
      dispatch(Module.setLoadingFlg(false));
      const messageText = messagesUtils.getMessageTextFromSession();
      const messageType = messagesUtils.getMessageTypeFromSession() || CONSTANTS.MESSAGE_TYPE_SUCCESS;
      if (messageText !== null) {
        // 削除エラーメッセージがあるので、設定。画面遷移しない。
        const setMessage: message = {
          message: messageText
          , messageType: messageType
        }
        dispatch(setMessages([setMessage]));
        messagesUtils.clearSessionMessage();
      } else {
        // 削除成功メッセージを設定します。
        const setMessage: message = {
          message: messagesUtils.getMessage("SUCCESS_DELETE", ["独自資格"])
          , messageType: CONSTANTS.MESSAGE_TYPE_SUCCESS
        }
        dispatch(setMessages([setMessage]));
        dispatch(Module.initDataRow());
        history.push(CONSTANTS.PATH_PRIME_QUALIFICATIONS_LIST);
        return;
      }
    }
  },
    [apiResult]
  );

  const backClicked = () => {
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());
    history.push(CONSTANTS.PATH_PRIME_QUALIFICATIONS_LIST);
  }

  const editClicked = () => {
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());
    dispatch(Module.selectCcusFlag(dataRow.ccusFlag === CONSTANTS.CCUS_FLAG.ON));
    history.push(CONSTANTS.PATH_PRIME_QUALIFICATIONS_EDIT);
  }

  const deleteClicked = () => {
    if (!window.confirm(messagesUtils.getMessage("CONFIRM_DELETE", ["独自資格"]))) {
      return;
    }
    // 共通メッセージ情報を初期化します。
    dispatch(initMessages());

    // API結果情報を初期化します。
    dispatch(initApiResult());

    let initParam: Model.deleteData.Request = {
      originalQualificationId: dataRow.originalQualificationId
      , ccusFlag: dataRow.ccusFlag
      , updateDatetime: dataRow.updateDatetime
      , ccusLevelUpdateDatetime1: dataRow.ccusLevelUpdateDatetime1
      , ccusLevelUpdateDatetime2: dataRow.ccusLevelUpdateDatetime2
      , ccusLevelUpdateDatetime3: dataRow.ccusLevelUpdateDatetime3
      , ccusLevelUpdateDatetime4: dataRow.ccusLevelUpdateDatetime4
    }
    dispatch(Module.setLoadingFlg(true));
    dispatch(Module.deleteDataLsitAsync(initParam));
  }

  // パラメータ定義
  interface AllowanceInspectionInterface {
    allowanceInspectionType: string;
    allowanceType: string;
    allowanceInspectionTime: number;
    monthlyAllowanceInspectionDays: number;
  }
  // 集計条件部品
  const AllowanceInspection = (props: AllowanceInspectionInterface) => {
    const allowanceInspectionType = props.allowanceInspectionType;
    const allowanceType = props.allowanceType;
    const allowanceInspectionTime = props.allowanceInspectionTime;
    const monthlyAllowanceInspectionDays = props.monthlyAllowanceInspectionDays;
    if (allowanceInspectionType === CONSTANTS.ALLOWANCE_INSPECTION_TYPE.NONE.code ) {
      if (allowanceType === CONSTANTS.ALLOWANCE_TYPE.DAILY.code) {
        return (
          <DetailForm.Item label="集計条件">
            <span>1分以上の労働時間の入力がある作業日を集計対象とする</span>
          </DetailForm.Item>
        )
      } else if (allowanceType === CONSTANTS.ALLOWANCE_TYPE.MONTHLY.code) {
        return (
          <DetailForm.Item label="集計条件">
            <span>1分以上の労働時間の入力がある作業日があれば集計対象とする</span>
          </DetailForm.Item>
        )
      }
    } else {
      if (allowanceType === CONSTANTS.ALLOWANCE_TYPE.DAILY.code) {
        return (
          <DetailForm.Item label="集計条件">
            <span>{allowanceInspectionTime}時間以上の作業日のみ集計対象とする</span>
          </DetailForm.Item>
        )
      } else if (allowanceType === CONSTANTS.ALLOWANCE_TYPE.MONTHLY.code) {
        return (
          <DetailForm.Item label="集計条件">
            <span>{allowanceInspectionTime}時間以上の作業日が月{monthlyAllowanceInspectionDays}日以上ある場合のみ集計対象とする </span>
          </DetailForm.Item>
        )
      }
    }
    return (<></>);
  }

  // パラメータ定義
  interface AllowanceAmountInterface {
    allowanceType: string;
    allowanceAmount: number;
  }
  // 手当金額部品
  const AllowanceAmount = (props: AllowanceAmountInterface) => {
    const allowanceType = props.allowanceType;
    const allowanceAmount = props.allowanceAmount;
    if (allowanceType === CONSTANTS.ALLOWANCE_TYPE.DAILY.code
      || allowanceType === CONSTANTS.ALLOWANCE_TYPE.MONTHLY.code
    ) {
      return (
        <DetailForm.Item label="手当金額">
          <span>{formatUtils.formatNumberComma(allowanceAmount)}</span>
        </DetailForm.Item>
      );
    }
    return (<></>);
  }

  // パラメータ定義
  interface LevelRangeToInterface {
    allowanceType: string;
    levelRangeTo: number;
  }
  // 対象次数部品
  const LevelRangeTo = (props: LevelRangeToInterface) => {
    const allowanceType = props.allowanceType;
    const levelRangeTo = props.levelRangeTo;
    if (allowanceType === CONSTANTS.ALLOWANCE_TYPE.DAILY.code
      || allowanceType === CONSTANTS.ALLOWANCE_TYPE.MONTHLY.code
    ) {
      return (
        <DetailForm.Item label="対象次数">
          <span>{constantsUtils.getLabelOf(CONSTANTS.LEVEL_RANGE_TO, String(levelRangeTo))}</span>
        </DetailForm.Item>
      );
    }
    return (<></>);
  }

  // パラメータ定義
  interface CeilingDailyAllowanceAmountInterface {
    allowanceType: string;
    ceilingDailyAllowanceAmount: number;
    ceilingDailyAllowanceInspectionDays: number;
  }
  // 月手当への切り替え部品
  const CeilingDailyAllowanceAmount = (props: CeilingDailyAllowanceAmountInterface) => {
    const allowanceType = props.allowanceType;
    const ceilingDailyAllowanceAmount = props.ceilingDailyAllowanceAmount;
    const ceilingDailyAllowanceInspectionDays = props.ceilingDailyAllowanceInspectionDays;
    if (allowanceType === CONSTANTS.ALLOWANCE_TYPE.DAILY.code) {
      return (
        <DetailForm.Item label="月手当への切り替え">
          {(ceilingDailyAllowanceInspectionDays != null
            && ceilingDailyAllowanceAmount != null)
            ? <span>労働日数が{ formatUtils.formatNumberComma(ceilingDailyAllowanceInspectionDays) } 日以上の場合は定額 {formatUtils.formatNumberComma(ceilingDailyAllowanceAmount)} 円となります</span>
            : <span>なし</span>
          }
        </DetailForm.Item>
      );
    }
    return (<></>);
  }

  // パラメータ定義
  interface CcusLevelFormInterface {
    ccusLevel: number;
  }
  // CCUSレベル別部品
  const CcusLevelForm = (props: CcusLevelFormInterface) => {
    const ccusLevel = props.ccusLevel;
    const levelLabel = ccusLevel == 4 ? "レベル４（金）" : ccusLevel == 3 ? "レベル３（銀）" : ccusLevel == 2 ? "レベル２（青）" : "レベル１（白）";
    const allowanceType = dataRow["ccusAllowanceType" + ccusLevel];
    const allowanceInspectionType = dataRow["ccusAllowanceInspectionType" + ccusLevel];
    const allowanceInspectionTime = dataRow["ccusAllowanceInspectionTime" + ccusLevel];
    const monthlyAllowanceInspectionDays = dataRow["ccusMonthlyAllowanceInspectionDays" + ccusLevel];
    const allowanceAmount = dataRow["ccusAllowanceAmount" + ccusLevel];
    const levelRangeTo = dataRow["ccusLevelRangeTo" + ccusLevel];
    const ceilingDailyAllowanceAmount = dataRow["ccusCeilingDailyAllowanceAmount" + ccusLevel];
    const ceilingDailyAllowanceInspectionDays = dataRow["ccusCeilingDailyAllowanceInspectionDays" + ccusLevel];
    return (
      <>
        <div className={styles.headline}>
          <span>{levelLabel}</span>
        </div>
        <DetailForm className={styles.detailform} >
          <DetailForm.Item label="手当区分">
            <span>{constantsUtils.getLabelOf(CONSTANTS.ALLOWANCE_TYPE, allowanceType)}</span>
          </DetailForm.Item>

          <AllowanceInspection
            allowanceType={allowanceType}
            allowanceInspectionType={allowanceInspectionType}
            allowanceInspectionTime={allowanceInspectionTime}
            monthlyAllowanceInspectionDays={monthlyAllowanceInspectionDays}
          />

          <AllowanceAmount
            allowanceType={allowanceType}
            allowanceAmount={allowanceAmount}
          />

          <LevelRangeTo
            allowanceType={allowanceType}
            levelRangeTo={levelRangeTo}
          />

          <CeilingDailyAllowanceAmount
            allowanceType={allowanceType}
            ceilingDailyAllowanceAmount={ceilingDailyAllowanceAmount}
            ceilingDailyAllowanceInspectionDays={ceilingDailyAllowanceInspectionDays}
          />
        </DetailForm>
      </>
    );
  }

  const CcusFlagFrom = () => {
    return (
      <>
        <DetailForm className={styles.detailform} >
          <DetailForm.Item label="技能レベル適用" >
            <div className={styles.deadLineDuration}>
              <span>{dataRow.ccusFlag === CONSTANTS.CCUS_FLAG.ON ? "あり" : "なし"}</span>
            </div>
          </DetailForm.Item>

        </DetailForm>
        <br /><br /><br />
        {dataRow.ccusFlag === CONSTANTS.CCUS_FLAG.ON ? <CcusForm /> : <DetailFormArea />}
        <br /><br /><br />
      </>
    )
  }

  const CcusForm = () => {
    return (
      <>
        <DetailForm className={styles.detailform} >
          <DetailForm.Item label="独自資格番号">
            <span>{dataRow.originalQualificationNo}</span>
          </DetailForm.Item>

          <DetailForm.Item label="独自資格名">
            <span>{dataRow.originalQualificationName}</span>
          </DetailForm.Item>

          <DetailForm.Item label="有効期限">
            <span>{formatUtils.formatDuration(dataRow.deadlineStartDate, dataRow.deadlineEndDate)}</span>
          </DetailForm.Item>

          <DetailForm.Item label="備考１">
            <span className={styles.remarks}>{dataRow.remarks1}</span>
          </DetailForm.Item>

          <DetailForm.Item label="備考２">
            <span className={styles.remarks}>{dataRow.remarks2}</span>
          </DetailForm.Item>
        </DetailForm>

        <CcusLevelForm ccusLevel={4} />
        <CcusLevelForm ccusLevel={3} />
        <CcusLevelForm ccusLevel={2} />
        <CcusLevelForm ccusLevel={1} />
      </>
    )
  }

  // 独自資格詳細Formを描画します。
  const DetailFormArea = () => {
    return (
      <>
        <DetailForm className={styles.detailform} >
          <DetailForm.Item label="独自資格番号">
            <span>{dataRow.originalQualificationNo}</span>
          </DetailForm.Item>

          <DetailForm.Item label="独自資格名">
            <span>{dataRow.originalQualificationName}</span>
          </DetailForm.Item>

          <DetailForm.Item label="手当区分">
            <span>{constantsUtils.getLabelOf(CONSTANTS.ALLOWANCE_TYPE, dataRow.allowanceType)}</span>
          </DetailForm.Item>

          <AllowanceInspection
            allowanceInspectionType={dataRow.allowanceInspectionType}
            allowanceType={dataRow.allowanceType}
            allowanceInspectionTime={dataRow.allowanceInspectionTime}
            monthlyAllowanceInspectionDays={dataRow.monthlyAllowanceInspectionDays}
          />

          <AllowanceAmount
            allowanceType={dataRow.allowanceType}
            allowanceAmount={dataRow.allowanceAmount}
          />

          <LevelRangeTo
            allowanceType={dataRow.allowanceType}
            levelRangeTo={dataRow.levelRangeTo}
          />

          <CeilingDailyAllowanceAmount
            allowanceType={dataRow.allowanceType}
            ceilingDailyAllowanceAmount={dataRow.ceilingDailyAllowanceAmount}
            ceilingDailyAllowanceInspectionDays={dataRow.ceilingDailyAllowanceInspectionDays}
          />

          <DetailForm.Item label="有効期限">
            <span>{formatUtils.formatDuration(dataRow.deadlineStartDate, dataRow.deadlineEndDate)}</span>
          </DetailForm.Item>

          <DetailForm.Item label="備考１">
            <span className={styles.remarks}>{dataRow.remarks1}</span>
          </DetailForm.Item>

          <DetailForm.Item label="備考２">
            <span className={styles.remarks}>{dataRow.remarks2}</span>
          </DetailForm.Item>
        </DetailForm>
        <br /><br /><br />
      </>
    )
  }

  // フッターボタンエリアを描画します。
  const ButtonArea = () => {
    return (
      <FooterButtonArea>
        <AuthButton
          name={"戻る"}
          size={"large"}
          shape={"round"}
          className={AuthButtonStyles.backButtonFixed}
          onClick={backClicked}
        />
        <AuthButton
          name={"編集"}
          authorities={[
            AuthButtonAuthorities.primeSystemMngAuth
          ]}
          size={"large"}
          shape={"round"}
          onClick={editClicked}
        />
        <AuthButton
          name={"削除"}
          className={styles.customButtonColor}
          authorities={[
            AuthButtonAuthorities.primeSystemMngAuth
          ]}
          size={"large"}
          shape={"round"}
          onClick={deleteClicked}
        />
      </FooterButtonArea>
    )
  }

  return (

    <Layout>
      <Header />
      <Content>
        <FunctionTitle title={props.title} />
        <CommonMessage />
        <CcusFlagFrom />
      </Content>
      <ButtonArea />
      <Footer />
    </Layout>
  );
}

